export default __webpack_public_path__ + "static/media/sub-category-hair-beauty-hair-stylist.83381600.jpg";